"use client"

import { LoaderPinwheel } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LoaderPinwheelIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LoaderPinwheelIcon = component(Icon)({ as: LoaderPinwheel })
